const initialState = {
  board: [],
  playerBalance: 0,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_BOARD':
      return { ...state, board: action.payload };
    case 'SET_BALANCE':
      return { ...state, playerBalance: action.payload };
    default:
      return state;
  }
};

export default reducer;
